import { forwardRef } from 'react'
import { Box as MuiBox } from '@mui/material'

export const Box = forwardRef(({ children, sx, ...props }, ref) => (
  <MuiBox ref={ref} sx={{ boxSizing: 'border-box', ...sx }} {...props}>
    {children}
  </MuiBox>
))
